// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table__body[data-v-0f071035] {\n  width: 100%;\n  table-layout: fixed !important;\n}\n.text_overflow[data-v-0f071035] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 400px;\n}\n.pup_card[data-v-0f071035] {\n  width: 200px;\n  border-radius: 5px;\n  padding: 5px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-size: 12px;\n  line-height: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
